import { Chat } from './chat';

export const initChat = (): void => {
  Chat.init();
};
